module.exports = __webpack_public_path__ + "static/img/2.606c47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/2.png
// module id = 131
// module chunks = 2